import { render, staticRenderFns } from "./OrderCardMobile.vue?vue&type=template&id=66f46388&"
import script from "./OrderCardMobile.vue?vue&type=script&lang=ts&"
export * from "./OrderCardMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports